interface CategoryQuestionsKeyText {
	key: string;
	text: string;
	sequence: number;
}

export const CATEGORY_QUESTIONS_KEY_TEXT: CategoryQuestionsKeyText[] = [
	{
		sequence: 1,
		key: 'lift_lower_loads_2_25kg',
		text: 'Lifting and/or lowering loads weighing more than 2 kg and up to 25 kg?'
	},
	{
		sequence: 2,
		key: 'lift_lower_frequency_1_360_per_hour',
		text: 'Does the worker perform lifting/lowering operations daily and cyclically with a frequency of ≥ 1 per hour or ≤ 360 per hour? (If done sporadically, indicate "No")'
	},
	{
		sequence: 3,
		key: 'lift_lower_loads_over_25kg',
		text: 'Lifting and/or lowering loads weighing more than 25 kg?'
	},
	{
		sequence: 1,
		key: 'lift_above_shoulder_30cm',
		text: 'Does the worker lift, hold, and deposit the load exceeding 30 cm above shoulder height with their hands?'
	},
	{
		sequence: 2,
		key: 'lift_horizontally_80cm_from_ankles',
		text: 'Does the worker lift, hold, and deposit the load more than 80 cm horizontally from the midpoint between the ankles?'
	},
	{
		sequence: 3,
		key: 'twist_bend_waist_30_degrees',
		text: 'Between lifting and depositing the load, does the worker twist or bend their waist more than 30º to either side (or both) from the sagittal plane?'
	},
	{
		sequence: 4,
		key: 'irregular_difficult_to_grasp_loads',
		text: 'Do the loads have irregular shapes, are difficult to grasp, deform, or have movement inside?'
	},
	{
		sequence: 5,
		key: 'lift_with_one_arm',
		text: 'Does the worker lift, hold, and deposit the load with one arm?'
	},
	{
		sequence: 6,
		key: 'early_signs_diseases_article_1',
		text: 'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?'
	},
	{
		sequence: 1,
		key: 'push_pull_cyclical_tasks_daily',
		text: 'Are cyclical tasks performed daily, with a frequency of ≥ 1 movement per day? (If sporadic, indicate “No”)'
	},
	{
		sequence: 2,
		key: 'push_pull_distance_over_60m',
		text: 'Does the worker move by pushing and/or pulling an object over a distance greater than 60 meters?'
	},
	{
		sequence: 3,
		key: 'push_pull_force_over_34kg',
		text: 'Are objects (bags, boxes, furniture, machines, etc.) pushed or pulled cyclically with a force measured with a dynamometer exceeding 34 kg?'
	},
	{
		sequence: 1,
		key: 'push_initial_effort_12kg_men_10kg_women',
		text: 'Is an initial effort required to push the rolling object measured with a dynamometer >= 12 kg for men or 10 kg for women?'
	},
	{
		sequence: 2,
		key: 'pull_initial_effort_10kg',
		text: 'Is an initial effort required to pull the rolling object measured with a dynamometer >= 10 kg for men or women?'
	},
	{
		sequence: 3,
		key: 'rolling_object_difficulty_uneven_surface',
		text: 'Is the rolling object pushed and/or pulled with difficulty (the sliding surface is uneven, there are ramps to go up or down, there are breaks or obstacles in the path, wheels in poor condition, poorly designed handle, etc.)?'
	},
	{
		sequence: 4,
		key: 'rolling_object_one_hand_uncomfortable_height',
		text: 'Can the rolling object not be pushed and/or pulled with both hands, and if allowed, is the hand support at an uncomfortable height (above the chest or below the waist)?'
	},
	{
		sequence: 5,
		key: 'rolling_object_maintained_effort_motion',
		text: 'In the act of pushing and/or pulling, is the initial effort required significantly maintained once the object is in motion (is there wheel jamming, jerking, or lack of uniform sliding)?'
	},
	{
		sequence: 6,
		key: 'rolling_object_one_hand_only',
		text: 'Does the worker push or pull the rolling object using only one hand?'
	},
	{
		sequence: 7,
		key: 'push_pull_early_signs_diseases_article_1',
		text: 'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?'
	},
	{
		sequence: 1,
		key: 'transport_loads_2_25kg',
		text: 'Manually transporting loads weighing more than 2 kg and up to 25 kg?'
	},
	{
		sequence: 2,
		key: 'transport_holding_load_over_1m',
		text: 'Does the worker move while manually holding the load over a distance greater than 1 meter?'
	},
	{
		sequence: 3,
		key: 'transport_cyclical_daily',
		text: 'Is it performed daily in a cyclical manner? (if sporadic, indicate "No")'
	},
	{
		sequence: 4,
		key: 'transport_distance_over_20m',
		text: 'Is manual transport of loads over a distance greater than 20 meters?'
	},
	{
		sequence: 5,
		key: 'transport_loads_over_25kg',
		text: 'Is manual transport of loads weighing more than 25 kg?'
	},
	{
		sequence: 1,
		key: 'transport_1_10m_cumulative_mass_10000kg',
		text: 'Under normal lifting conditions, does the worker transport the load between 1 and 10 meters with a cumulative mass (the product of mass by frequency) greater than 10,000 kg during the usual workday?'
	},
	{
		sequence: 2,
		key: 'transport_10_20m_cumulative_mass_6000kg',
		text: 'Under normal lifting conditions, does the worker transport the load between 10 and 20 meters with a cumulative mass (the product of mass by frequency) greater than 6,000 kg during the usual workday?'
	},
	{
		sequence: 3,
		key: 'transport_irregular_difficult_loads',
		text: 'Do the loads have irregular shapes, are difficult to grasp, deform, or have movement inside?'
	},
	{
		sequence: 4,
		key: 'transport_early_signs_diseases_article_1',
		text: 'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?'
	},
	{
		sequence: 1,
		key: 'standing_2_consecutive_hours_no_sitting',
		text: 'Does the job require standing for 2 consecutive hours or more without the possibility of sitting?'
	},
	{
		sequence: 1,
		key: 'standing_3_hours_limited_mobility_100m_per_hour',
		text: 'Does the job involve standing for 3 consecutive hours or more without the possibility of sitting and with limited mobility (walking no more than 100 meters/hour)?'
	},
	{
		sequence: 2,
		key: 'standing_2_hours_lifting_transporting_over_2kg',
		text: 'Does the job involve standing for 2 consecutive hours or more without the possibility of sitting or moving, or with limited mobility, lifting and/or transporting loads > 2 kg?'
	},
	{
		sequence: 3,
		key: 'standing_prolonged_extreme_temperature_humidity',
		text: 'Are tasks performed with prolonged standing in environments where temperature and humidity exceed legally permissible limits and require physical activity?'
	},
	{
		sequence: 4,
		key: 'standing_early_signs_diseases_article_1',
		text: 'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?'
	},
	{
		sequence: 1,
		key: 'repetitive_movements_daily_4_hours_cyclical',
		text: 'Performing daily, one or more tasks using the upper limbs for 4 or more hours during the regular workday in a cyclical manner (continuously or alternately)?'
	},
	{
		sequence: 1,
		key: 'repetitive_upper_limbs_active_40_percent_cycle',
		text: 'Are the upper limbs active for more than 40% of the total work cycle time?'
	},
	{
		sequence: 2,
		key: 'repetitive_effort_borg_3_over_6_seconds_once_per_minute',
		text: 'Is there an effort greater than moderate at 3 on the Borg Scale, for more than 6 seconds and more than once per minute?'
	},
	{
		sequence: 3,
		key: 'repetitive_effort_borg_over_7',
		text: 'Is there an effort greater than 7 on the Borg scale?'
	},
	{
		sequence: 4,
		key: 'repetitive_early_manifestations_diseases_article_1',
		text: 'Does the worker show any early manifestations of the diseases mentioned in Article 1 of this Resolution?'
	},
	{
		sequence: 1,
		key: 'forced_posture_regularly_workday',
		text: 'Adopting forced postures regularly during the workday, with or without applying force. (Occasional postures should not be considered)?'
	},
	{
		sequence: 1,
		key: 'forced_posture_neck_extension_flexion_lateralization_rotation',
		text: 'Is the neck in extension, flexion, lateralization, and/or rotation?'
	},
	{
		sequence: 2,
		key: 'forced_posture_arms_above_shoulder_supination_pronation_rotation',
		text: 'Are the arms above shoulder level or with movements of supination, pronation, or rotation?'
	},
	{
		sequence: 3,
		key: 'forced_posture_wrists_hands_flexion_extension_ulnar_radial_deviation',
		text: 'Are the wrists and hands in flexion, extension, ulnar or radial deviation?'
	},
	{
		sequence: 4,
		key: 'forced_posture_waist_flexion_extension_lateralization_rotation',
		text: 'Is the waist in flexion, extension, lateralization, and/or rotation?'
	},
	{
		sequence: 5,
		key: 'forced_posture_lower_limbs_kneeling_squatting',
		text: 'Are the lower limbs working in a kneeling or squatting position?'
	},
	{
		sequence: 6,
		key: 'forced_posture_early_signs_diseases_article_1',
		text: 'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?'
	},
	{
		sequence: 1,
		key: 'hand_arm_vibration_tools_produce_vibrations',
		text: 'Working with tools that produce vibrations (jackhammer, drill, screwdrivers, polishers, grinders, others)?'
	},
	{
		sequence: 2,
		key: 'hand_arm_vibration_holding_pieces_while_machining',
		text: 'Holding pieces with hands while they are being machined?'
	},
	{
		sequence: 3,
		key: 'hand_arm_vibration_holding_levers_steering_wheels',
		text: 'Holding levers, steering wheels, etc. that transmit vibrations?'
	},
	{
		sequence: 1,
		key: 'hand_arm_vibration_exceeds_table_1_annex_v_resolution_295_03',
		text: 'Does the vibration value exceed the limits established in Table I, in the section corresponding to Hand-Arm Vibration, Annex V, Resolution MTEySS N° 295/03?'
	},
	{
		sequence: 2,
		key: 'hand_arm_vibration_early_signs_diseases_article_1',
		text: 'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?'
	},
	{
		sequence: 1,
		key: 'whole_body_vibration_tools_produce_vibrations',
		text: 'Working with tools that produce vibrations (jackhammer, drill, screwdrivers, polishers, grinders, others)?'
	},
	{
		sequence: 2,
		key: 'whole_body_vibration_holding_pieces_while_machining',
		text: 'Holding pieces with hands while they are being machined?'
	},
	{
		sequence: 3,
		key: 'whole_body_vibration_holding_levers_steering_wheels',
		text: 'Holding levers, steering wheels, etc. that transmit vibrations?'
	},
	{
		sequence: 1,
		key: 'whole_body_vibration_exceeds_table_1_annex_v_resolution_295_03',
		text: 'Does the vibration value exceed the limits established in Table I, in the section corresponding to Hand-Arm Vibration, Annex V, Resolution MTEySS N° 295/03?'
	},
	{
		sequence: 2,
		key: 'whole_body_vibration_early_signs_diseases_article_1',
		text: 'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?'
	},
	{
		sequence: 1,
		key: 'thermal_comfort_uncomfortable_temperatures_workplace',
		text: 'Are uncomfortable temperatures perceived in the workplace for performing tasks?'
	},
	{
		sequence: 1,
		key: 'thermal_comfort_fanger_curve_outside_comfort_zone',
		text: 'Is the result of using the Fanger Comfort Curve outside the comfort zone?'
	},
	{
		sequence: 1,
		key: 'contact_stress_body_pressure_tool_surface_machine',
		text: 'Is any part of the body resting under pressure against a tool, work surface, machine tool, or parts and materials?'
	},
	{
		sequence: 1,
		key: 'contact_stress_rest_wrist_forearm_armpit_thigh_other_body_segment',
		text: 'Does the worker rest their wrist, forearm, armpit, thigh, or another body segment on a sharp or edged surface?'
	},
	{
		sequence: 2,
		key: 'contact_stress_hand_tools_press_fingers_dominant_hand_palm',
		text: 'Does the worker use hand tools or manipulate parts that press on their fingers and/or dominant hand palm?'
	},
	{
		sequence: 3,
		key: 'contact_stress_percussion_movements_parts_tools',
		text: 'Does the worker perform percussion movements on parts or tools?'
	},
	{
		sequence: 4,
		key: 'contact_stress_early_signs_diseases_article_1',
		text: 'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?'
	}
];
